<template>
  <div>
    <div v-if="!lensId">Sorry, I cannot find this lens</div>

    <v-container v-if="lensData">
      <v-row justify="center">
        <v-col cols="12">
          <v-card flat class="gradCard">
            <div
              class="d-flex flex-row flex-wrap pa-5 align-center justify-center justify-sm-start"
            >
              <v-img
                v-if="lensData.image"
                :src="mediaPath + lensData.image"
                max-width="300"
                max-height="80"
                contain
              ></v-img>
              <div class="text-center mt-4 mt-sm-0 pl-md-6">
                <div class="title grayText">{{ lensData.name }}</div>

                <v-img
                  v-if="companyImageForId(lensData.companyId)"
                  :src="companyImageForId(lensData.companyId)"
                  height="45"
                  width="250"
                  contain
                ></v-img>
                <h4 v-else>{{ companyNameForId(lensData.companyId) }}</h4>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12" md="8">
          <v-card flat class="cardContent">
            <div class="cardTitle">Parameters</div>
            <div class="pa-4">
              <div v-if="!lensData.parameters">Made-to-order</div>
              <table class="paramTable">
                <tbody
                  v-for="(row, i) in lensData.parameters"
                  :key="'param' + i"
                >
                  <tr v-if="row.text && row.text != ''">
                    <th>{{ row.label }}</th>
                    <td>{{ row.text }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card>

          <v-card flat class="cardContent my-4">
            <div class="cardTitle">Material Options</div>
            <div class="pa-4">
              <material-summary
                :materials="lensData.materials"
                :rgpOptions="rgpOptions"
                :materialList="materialList"
                @getMaterialList="$emit('getMaterialList')"
              ></material-summary>
              <div v-if="lensData.materialText">
                {{ lensData.materialText }}
              </div>
            </div>
          </v-card>

          <v-card flat class="cardContent my-4" v-if="lensData.otherInfo">
            <div class="cardTitle">Information</div>
            <div class="pa-4">
              <vue-markdown>{{ lensData.otherInfo }}</vue-markdown>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card flat class="cardContent">
            <div class="cardTitle">Links, Docs, & Tags</div>
            <div class="ma-4">
              <div v-if="lensData.url" class="mb-2">
                <a :href="lensData.url" target="_blank">
                  <v-icon color="primary" class="mr-2">mdi-web</v-icon>Lens
                  Website
                  <v-icon x-small class="ml-2" color="primary"
                    >mdi-open-in-new</v-icon
                  >
                </a>
              </div>
              <div v-for="(row, i) in media.pdfs" :key="'pdf' + i" class="mb-2">
                <pdf-viewer
                  :url="mediaPath + row.file"
                  :title="row.label ? row.label : 'pdf'"
                  :backBtnLabel="`Back to ${lensData.name} Listing`"
                  :showCalcs="true"
                >
                  <div class="linkLike">
                    <v-icon color="primary" class="mr-2"
                      >mdi-file-pdf-box</v-icon
                    >

                    {{ row.label ? row.label : "pdf" | titleize }}
                    <v-icon x-small class="ml-2" color="primary"
                      >mdi-eye-outline</v-icon
                    >
                  </div>
                </pdf-viewer>
              </div>
            </div>

            <div
              class="ma-4"
              v-if="rgpOptions && lensData.tags && lensData.tags.length"
            >
              <v-divider class="mb-2"></v-divider>
              <div class="overline mt-2">Tags</div>
              <rgp-tag-selector
                :rgpOptions="rgpOptions"
                :tagGroups="rgpOptions.tagGroups"
                :allowedTags="lensData.tags"
                :displayOnly="true"
              ></rgp-tag-selector>
              <!-- <div class="overline mt-2">Tags</div>
              <div v-for="(tgArr, tg) in tags" :key="'tg' + tg" class="mb-2">
                <v-chip
                  small
                  label
                  :color="`hsl(${tg * 4}deg 100% 90%)`"
                  @click="goToTag(rgpOptions.tags[tg].slug)"
                >
                  {{ rgpOptions.tags[tg].name }}
                </v-chip>
                <div class="ml-4">
                  <v-chip
                    small
                    label
                    class="my-1 mx-1"
                    v-for="(childTag, i) in tgArr"
                    :key="'childTag_' + tg + i"
                    :color="`hsl(${tg * 4}deg 100% 95%)`"
                    @click="goToTag(rgpOptions.tags[childTag].slug)"
                  >
                    {{ rgpOptions.tags[childTag].name }}
                  </v-chip>
                </div>
              </div>
              <div class="caption" style="font-size: 10px !important">
                (Clicking an item will search for other lenses with that tag)
              </div> -->
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="media.images && media.images.length">
        <v-col>
          <div class="overline">Related Media</div>
          <div class="caption">Click an image for full size</div>
          <!-- {{ mediaImages }} -->
          <dialog-lightbox
            :imagePath="mediaPath"
            :images="media.images"
            :iconHeight="350"
            :iconWidth="350"
            :canShowQuickCalcs="true"
          ></dialog-lightbox>
        </v-col>
      </v-row>
    </v-container>

    <!-- {{ lensData }} -->
  </div>
</template>

<script>
// import Name from "../dir/file";
import ApiServices from "@/services/ApiServices";
import RgpOptionsMixin from "@/assets/js/rgps/RgpOptionsMixin.js";
import VueMarkdown from "@adapttive/vue-markdown";
import DialogLightbox from "@/components/universalStuff/DialogLightbox";
import RgpTagSelector from "./RgpTagSelector.vue";

export default {
  name: "RgpDetails",
  props: {
    isAdmin: null,
    rgpOptions: null,
    materialList: null,
  },
  components: {
    VueMarkdown,
    DialogLightbox,
    RgpTagSelector,
    MaterialSummary: () => import("@/components/gpStuff/MaterialSummary"),
    PdfViewer: () => import("@/components/universalStuff/PdfViewer.vue"),
  },
  mixins: [RgpOptionsMixin],
  data: function () {
    return {
      loading: false,
      lensId: null,
      companyLogoPath: "https://www.eyedock.com/images/rgp_companies/",
      mediaPath: "https://www.eyedock.com/images/rgp_media/",
      lensData: null,
      title: "Lens Details",
    };
  },
  methods: {
    getDetails() {
      if (!this.lensId) return;
      this.loading = true;
      ApiServices.genericApiCall("/rgps/lens/" + this.lensId)
        .then((response) => {
          if (response.data) this.lensData = response.data.details;
          if (this.lensData.name) this.title = this.lensData.name;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rowClick(item) {
      console.log(item);
    },
    goToTag(slug) {
      let url = "/rgps/tag/" + slug;
      this.$router.push({ path: url });
    },
    // companyNameForId(id) ->  in mixin
  },
  computed: {
    media: function () {
      let rtn = { images: [], pdfs: [] };
      let media = this.lensData?.media;
      let primaryImage = this.lensData?.image;
      if (!media) return rtn;
      media.forEach((row) => {
        let f = row.file;
        if (row.fileType == "image" && f != primaryImage) rtn.images.push(f);
        if (row.fileType == "pdf") rtn.pdfs.push(row);
      });
      return rtn;
    },
    // tags: function () {
    //   //   console.log("tags");
    //   let rtn = {};
    //   let allTags = this.rgpOptions?.tags;
    //   let tagGroups = this.rgpOptions?.tagGroups;
    //   let lensTags = this.lensData?.tags;
    //   if (!lensTags || !allTags) return rtn;
    //   let groupKeys = Object.keys(tagGroups);

    //   groupKeys.forEach((gk) => {
    //     if (lensTags.includes(gk)) {
    //       rtn[gk] = [];
    //       let t4g = tagGroups[gk];
    //       //   console.log("t4g " + gk, t4g);
    //       t4g.forEach((id) => {
    //         if (lensTags.includes(id)) rtn[gk].push(id);
    //       });
    //     }
    //   });

    //   return rtn;
    // },
  },
  mounted() {
    this.lensId = this.$route.params.slug;
    this.getDetails();
  },

  metaInfo() {
    return {
      title: "EyeDock/RGPs | " + this.title,
    };
  },
};
</script>

<style scoped>
th {
  text-align: left;
  padding-right: 2em;
}
.cardContent {
  border: 1px solid #c5c5c5;
  margin: 0 0px;
  font-size: 14px;
  /* box-shadow: 2px 3px 5px 1px #80808014 !important; */
}

.cardTitle {
  /* color: #4d4d4d; */
  background-color: #e8f2f9;
  border: 1px solid #a5c3d8;
  margin: -1px -1px;
  /* box-shadow: 0px 3px 5px 1px #80808014 !important; */
}
.gradCard {
  background-image: linear-gradient(136deg, #fff 40%, #e3f2fd);
  border: 1px solid #b5c9d6;
}

table {
  border-collapse: collapse;
}

.paramTable td,
.paramTable th {
  border: 1px solid #e4e4e4;
  padding: 1px 7px;
}
</style>
